module.exports = {
  title: 'Account Settings'
}



// WEBPACK FOOTER //
// ../i18n/en/accountSettings.js